import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EpagoService {

  constructor(private readonly http: HttpClient) { }

  generateVtexPayment(
    env: 'QA' | 'DEV',
    merchantKey: string,
    merchantToken: string,
    generatePaymentBody: any
  ): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'X-VTEX-API-AppKey': merchantKey,
        'X-VTEX-API-AppToken': merchantToken,
        'Content-Type': "application/json"
      })
    };

    const baseUrls: Record<string, string> = {
      QA: 'https://qa.pagoweb.pe/vtex',
      DEV: 'https://dev.pagoweb.pe/vtex'
    };

    const endpoint = baseUrls[env];
    const url = `${endpoint}/v1/payments`;
    return this.http.post<any>(url, generatePaymentBody, httpOptions);
  }


}
